import { make } from 'vuex-pathify';
import moment from 'moment';
import * as _ from 'lodash';

const getDefaultState = () => {
  return {
    category: 'airportparking',
    dateA: '2019-12-12',
    dateB: '2019-12-15',
    dateC: '',
    dateD: '',
    timeA: '11:30',
    timeB: '12:45',
    timeC: '',
    timeD: '',
    agent: 'ONLINE',
    promo: '',
    passengers: 0,
    serviceCode: '',
    adults: "1",
    children: "0",
    infants: "0",
    website_id: 0,
    parking_days: 0,
    country: 0,
    resortA: 0,
    transfer_type: '',
    include_parking: 0,
    return: 0,
    manual_discount: 0,
    room1: '1',
    room2: '',
    rhp: 0,
    params: [],
    airportA: 1,
    _timestamp: new Date,
    quoteID: null,
    referrer: '',
    hotelToParking: false,
    utm: []
  }
}

// initial state
const state = getDefaultState();

const mutations = {
  ...make.mutations(state),
  clearQuote() {
    this.state.quote = getDefaultState();
  },
  async setQuote(context, quote) {

    const validateDates = async () => {
      let today = moment();

      // check dateA is in the future
      if(today.diff(quote.dateA) > 0) {
        quote.dateA = today.format('YYYY-MM-DD');
      }

      // check dateB is in the future and is later than dateA
      if(today.diff(quote.dateB) > 0 && quote.timeA >= quote.timeB) {
        let future = moment(today).add(7, 'd');
        quote.dateB = future.format('YYYY-MM-DD');
      }

      // calculate parking duration
      let duration = moment.duration(moment(quote.dateB).diff(moment(quote.dateA)));
      quote.parking_days = duration.asDays() === 0 ? 1 : Math.round(duration.asDays() + 1);
      
      return 
    }

    validateDates().then(() => {
      this.state.quoteTemp = _.cloneDeep(quote);
      this.state.quote = _.cloneDeep(quote);
    })
  }
};

const actions = {
  ...make.actions(state),
  async updateQuote(context, value) {
    let quote = {...state, ...value};
    await context.commit('setQuote', quote)
  },
  async clearQuote(context) {
    await context.commit('clearQuote')
  }
};

export default {
  namespaced: true,
  mutations,
  actions,
  state
};